import { createNativeStackNavigator } from "@react-navigation/native-stack";

export type TaskExecutionInstructionsParamList = {
  TaskExecutionInstructions: {
    taskId: string;
  };
};

export const TaskExecutionInstructionsStack =
  createNativeStackNavigator<TaskExecutionInstructionsParamList>();
